import * as React from 'react';
import * as styles from './DefaultCounter.css';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export var DefaultCounter = function DefaultCounter(props) {
  var currentSlide = props.currentSlide,
    totalSlides = props.totalSlides,
    rightOffset = props.rightOffset;
  return /*#__PURE__*/_jsx("div", {
    className: styles['default-counter-container'],
    style: {
      right: rightOffset
    },
    "data-testid": "DefaultCounter",
    children: /*#__PURE__*/_jsxs("div", {
      className: styles['default-counter'],
      children: [currentSlide, "/", totalSlides]
    })
  });
};